(function () {

    const siteInfo = window.SiteInfo?.Site || {};

    const sitePath = siteInfo.Path ?? '';
    const siteBaseUrl = siteInfo.BaseUrl ?? '';
    const domain = siteInfo.Domain ?? window.location.host;
    const baseUrl = (siteBaseUrl || window.location.origin + sitePath);

    const SEARCH_URL =
        `${baseUrl}/search/article-search`;

    const csrfToken =
        document.querySelector('input[name="__RequestVerificationToken"]')
            ?.value;

    const authorName =
        window.authorProfileData?.authorName ||
        document.querySelector('.author__name')
            ?.textContent
            ?.trim();

    if (!authorName) return;

    const loadingDiv =
        document.getElementById('loading');

    const errorDiv =
        document.getElementById('error-message');

    const articlesDiv =
        document.getElementById('articles-list');

    const mediaBaseUrl =
        `${window.location.protocol}//${domain}${sitePath}/media/`;

    async function fetchArticles() {

        try {
            loadingDiv.style.display = 'block';
            errorDiv.style.display = 'none';


            const searchResponse = await fetch(SEARCH_URL, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'RequestVerificationToken': csrfToken
                },
                body: JSON.stringify({
                    From: 0,
                    Size: 5,
                    ContentType: 'Article',
                    Word: 'any',
                    Keywords: [],
                    Title: '',
                    SortBy: 'Newest first',
                    FromDate: '',
                    ToDate: '',
                    Categories: [],
                    Authors: [authorName],
                    ArticleType: []
                })
            });

            if (!searchResponse.ok) {
                throw new Error(
                    `Search failed: ${searchResponse.status}`
                );
            }

            const searchData =
                await searchResponse.json();

            const results =
                Array.isArray(searchData)
                    ? searchData
                    : (searchData.results ||
                        searchData.Results ||
                        []);

            if (!results.length) {

                articlesDiv.innerHTML =
                    '<div class="col-12"><p class="text-muted">No articles found.</p></div>';

                return;
            }

            const html = results.map(article => {

                const imagePath =
                    article.images?.[0]?.media?.paths?.[0];

                const imageUrl =
                    imagePath
                        ? `${mediaBaseUrl}${imagePath}`
                        : '';

                const primaryCategory =
                    article.primaryCategory?.[0];

                const primaryCategoryRoute =
                    article.primaryCategoryAutoroute?.[0];

                const showPrimaryCategory =
                    article.primaryCategoryDisplay?.[0]
                        ?.trim()
                        ?.toLowerCase() === 'true';

                const author =
                    article.author?.[0];

                const authorRoute =
                    article.authorAutoroute?.[0];

                const authorInactive =
                    String(article.authorInactive?.[0]).toLowerCase() === 'true';

                const articleType =
                    article.articleType?.[0];

                return `
                    <div class="twocolumn col-md-6">
                        <div class="card h-100 border-0">

                    ${imageUrl ? `
                    <div class="card-image position-relative">

                    <a href="${baseUrl}/${article.link || '#'}">
                    <img
                    src="${imageUrl}"
                    class="card-img rounded-0 w-100 object-fit-cover h-100"
                    alt="${article.title || 'Article'}"
                    />
                    </a>

                    ${articleType ? `
                    <span class="card-articleType badge position-absolute rounded-0 start-0">
                    ${articleType}
                    </span>
                    ` : ''}

                    </div>
                    ` : ''}

                            <div class="card-body">

                                <div class="card-tags d-flex flex-wrap">

                                    ${primaryCategory && showPrimaryCategory ? `
                                       <a href="${baseUrl}/${primaryCategoryRoute || '#'}">
                                              ${primaryCategory?.split('/')[0].split('(')[0].trim()}
                                           </a>
                                    ` : ''} 

                                    ${author ? `
                                    ${primaryCategory && showPrimaryCategory
                                        ? '<span class="mx-2">|</span>'
                                        : ''
                                    }

                                    ${
                                        authorInactive
                                            ? `
                                                <p class="">
                                                    <em>
                                                        ${author}
                                                        ${article.author.length > 1 ? ' et al' : ''}
                                                    </em>
                                                </p>
                                            `
                                            : `
                                                <a href="${baseUrl}/${authorRoute || '#'}">
                                                    <em>
                                                        ${author}
                                                        ${article.author.length > 1 ? ' et al' : ''}
                                                    </em>
                                                </a>
                                            `
                                    }
                                ` : ''}

                                </div>
                                <h5 class="card-title fw-bold">
                                    <a href="${baseUrl}/${article.link || '#'}">
                                        ${article.title || 'No Title'}
                                    </a>
                                </h5>
                                <p class="card-summary card-text text-muted small">
                                    ${article.summary || ''}
                                </p>
                                ${(() => {
                        const pubRaw = article.publishDate;
                        if (!pubRaw) return '';
                        const pubDate = new Date(pubRaw);
                        if (isNaN(pubDate)) return '';
                        const month = pubDate.getMonth() + 1;
                        const year = pubDate.getFullYear();
                        const season = month >= 3 && month <= 5 ? 'Spring'
                            : month >= 6 && month <= 8 ? 'Summer'
                                : month >= 9 && month <= 11 ? 'Autumn'
                                    : 'Winter';
                        return `<p class="card-date">${season} ${year}</p>`;
                    })()}
                            </div>

                        </div>
                    </div>
                `;
            }).join('');

            articlesDiv.innerHTML = html;

        }
        catch (error) {

            errorDiv.style.display = 'block';

            errorDiv.textContent =
                `Error: ${error.message}`;
        }
        finally {

            loadingDiv.style.display = 'none';
        }
    }
    if (document.readyState === 'loading') {

        document.addEventListener(
            'DOMContentLoaded',
            fetchArticles,
            { once: true }
        );
    }
    else {
        fetchArticles();
    }

})();
